<div class="container">
  <div class="member-data">
    <div class="member-cell-start">
      <rt-avatar
        [type]="!!avatarThumbUrl() ? 'image' : 'initials'"
        [imageSrc]="avatarThumbUrl()"
        [fullName]="name()"
        [size]="'medium'"
        [context]="'admin'"
      />
    </div>
    <div class="member-cell-end">
      <div class="name-wrapper">
        <span class="name">{{ name() }}</span>
        @if (isOwner()) {
          <rt-badge
            color="draft"
            [text]="'tlc.members.isOwnerBadge' | translate | uppercase"
            class="badge"
          />
        }
      </div>
      <span class="email">{{ email() }}</span>
    </div>
  </div>
</div>
